import React from 'react'
import Dialog from '@mui/material/Dialog'

import TestInstructions from '../../../../../components/pages/Register/PassTheTest/TestInstructions'

const MyClassCategoriesTestInstructions = ({ open, onClose, onSubmit }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[800px] !px-[148px] !rounded-[10px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      <div className="text-[#F67443] w-full">
        <TestInstructions onSubmit={onSubmit} onCancel={onClose} />
      </div>
    </Dialog>
  )
}

export default MyClassCategoriesTestInstructions
